import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { FaQuestionCircle, FaRegQuestionCircle, FaTools } from 'react-icons/fa';
import axios from 'axios';
import Select from "react-select";
import SummernoteEditor from './summernote';

const QuestionCorrespondance = ({ onChange }) => {
    const [leftOptions, setLeftOptions] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);
    const [rightOptions, setRightOptions] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);
    const [selectedPairs, setSelectedPairs] = useState({});

    const notifyParent = (left, right, pairs) => {
        if (onChange) {
            onChange(left, right, pairs);
        }
    };

    const addLeftOption = () => {
        const newId = Math.max(...leftOptions.map(opt => opt.id), 0) + 1;
        const newLeftOptions = [...leftOptions, { id: newId, value: '' }];
        setLeftOptions(newLeftOptions);
        notifyParent(newLeftOptions, rightOptions, selectedPairs);
    };

    const addRightOption = () => {
        const newId = Math.max(...rightOptions.map(opt => opt.id), 0) + 1;
        const newRightOptions = [...rightOptions, { id: newId, value: '' }];
        setRightOptions(newRightOptions);
        notifyParent(leftOptions, newRightOptions, selectedPairs);
    };

    const removeLeftOption = (id) => {
        if (leftOptions.length > 2) {
            const newLeftOptions = leftOptions.filter(opt => opt.id !== id);
            setLeftOptions(newLeftOptions);
            const newPairs = { ...selectedPairs };
            delete newPairs[id];
            setSelectedPairs(newPairs);
            notifyParent(newLeftOptions, rightOptions, newPairs);
        }
    };

    const removeRightOption = (id) => {
        if (rightOptions.length > 2) {
            const newRightOptions = rightOptions.filter(opt => opt.id !== id);
            setRightOptions(newRightOptions);
            const newPairs = { ...selectedPairs };
            for (let key in newPairs) {
                if (newPairs[key] === id) {
                    delete newPairs[key];
                }
            }
            setSelectedPairs(newPairs);
            notifyParent(leftOptions, newRightOptions, newPairs);
        }
    };

    const updateLeftOption = (id, value) => {
        const newLeftOptions = leftOptions.map(opt =>
            opt.id === id ? { ...opt, value } : opt
        );
        setLeftOptions(newLeftOptions);
        notifyParent(newLeftOptions, rightOptions, selectedPairs);
    };

    const updateRightOption = (id, value) => {
        const newRightOptions = rightOptions.map(opt =>
            opt.id === id ? { ...opt, value } : opt
        );
        setRightOptions(newRightOptions);
        notifyParent(leftOptions, newRightOptions, selectedPairs);
    };

    const handlePairSelect = (leftId, rightId) => {
        if (!rightId) {
            const newPairs = { ...selectedPairs };
            delete newPairs[leftId];
            setSelectedPairs(newPairs);
            notifyParent(leftOptions, rightOptions, newPairs);
            return;
        }

        const newPairs = { ...selectedPairs };
        const rightInUse = Object.values(newPairs).includes(parseInt(rightId));
        if (rightInUse) {
            for (let key in newPairs) {
                if (newPairs[key] === parseInt(rightId)) {
                    delete newPairs[key];
                    break;
                }
            }
        }
        newPairs[leftId] = parseInt(rightId);
        setSelectedPairs(newPairs);
        notifyParent(leftOptions, rightOptions, newPairs);
    };

    return (
        <>
            <style>{`
                .correspondance-container {
                    background: #f8f9fa;
                    padding: 15px;
                    border-radius: 5px;
                    border: 1px solid #e9ecef;
                    margin-top: 10px;
                }

                .correspondance-mapping {
                    background: white;
                    border-radius: 5px;
                    border: 1px solid #dee2e6;
                }

                .correspondance-mapping .form-group {
                    padding: 8px 12px;
                    border-bottom: 1px solid #f1f3f5;
                    margin-bottom: 0 !important;
                }

                .correspondance-mapping .form-group:last-child {
                    border-bottom: none;
                }

                .correspondance-container .btn-sm {
                    padding: 0.25rem 0.5rem;
                    font-size: 0.875rem;
                    line-height: 1.5;
                    border-radius: 0.2rem;
                }

                .correspondance-container .form-control {
                    margin-right: 5px;
                }

                .correspondance-container .btn {
                    margin-left: 3px;
                }

                .correspondance-container .btn-group {
                    display: flex;
                    gap: 3px;
                    margin-left: 5px;
                }

                .type-selector {
                    border-left: 3px solid #1ab394;
                    background: #f8f9fa;
                    padding: 8px 12px;
                    border-radius: 4px;
                }
            `}</style>

            <div className="correspondance-container">
                <div className="row">
                    <div className="col-sm-6">
                        <h5 className="text-center">Items à associer</h5>
                        {leftOptions.map((option, index) => (
                            <div key={option.id} className="form-group d-flex align-items-center mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Item ${index + 1}`}
                                    value={option.value}
                                    onChange={(e) => updateLeftOption(option.id, e.target.value)}
                                />
                                <div className="btn-group">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeLeftOption(option.id)}
                                        disabled={leftOptions.length <= 2}
                                    >
                                        <i className="fa fa-minus"></i>
                                    </button>
                                    {index === leftOptions.length - 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={addLeftOption}
                                        >
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-sm-6">
                        <h5 className="text-center">Correspondances</h5>
                        {rightOptions.map((option, index) => (
                            <div key={option.id} className="form-group d-flex align-items-center mb-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Correspondance ${index + 1}`}
                                    value={option.value}
                                    onChange={(e) => updateRightOption(option.id, e.target.value)}
                                />
                                <div className="btn-group">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeRightOption(option.id)}
                                        disabled={rightOptions.length <= 2}
                                    >
                                        <i className="fa fa-minus"></i>
                                    </button>
                                    {index === rightOptions.length - 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={addRightOption}
                                        >
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <h5 className="text-center">Établir les correspondances</h5>
                        <div className="correspondance-mapping border p-3">
                            {leftOptions.map((leftOpt) => {
                                const currentPair = selectedPairs[leftOpt.id] || '';
                                return (
                                    <div key={leftOpt.id} className="form-group d-flex align-items-center mb-2">
                                        <span className="mr-2 font-weight-bold" style={{ minWidth: '120px' }}>
                                            {leftOpt.value || `Item ${leftOptions.indexOf(leftOpt) + 1}`}
                                        </span>
                                        <span className="mx-2">→</span>
                                        <select
                                            className="form-control"
                                            value={currentPair}
                                            onChange={(e) => handlePairSelect(leftOpt.id, e.target.value)}
                                        >
                                            <option value="">Sélectionner une correspondance</option>
                                            {rightOptions.map((rightOpt) => {
                                                const isUsed = Object.entries(selectedPairs).some(
                                                    ([key, value]) => value === rightOpt.id && parseInt(key) !== leftOpt.id
                                                );
                                                return (
                                                    <option
                                                        key={rightOpt.id}
                                                        value={rightOpt.id}
                                                        disabled={isUsed && currentPair !== rightOpt.id}
                                                    >
                                                        {rightOpt.value || `Correspondance ${rightOptions.indexOf(rightOpt) + 1}`}
                                                        {isUsed && currentPair !== rightOpt.id && ' (déjà utilisée)'}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="mt-2  text-muted small">
                    <i className="mr-2 fa fa-info-circle"></i>
                    Chaque correspondance ne peut être utilisée qu'une seule fois
                </div>
            </div>
        </>
    );
};

const Ajouter_qcm = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [domainesFr, setDomainesFr] = useState([]);
    const [domainesEn, setDomainesEn] = useState([]);
    const [groupeProcessusFr, setGroupeProcessusFr] = useState([]);
    const [groupeProcessusEn, setGroupeProcessusEn] = useState([]);
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [typeQuestionFr, setTypeQuestionFr] = useState('defaut');
    const [typeQuestionEn, setTypeQuestionEn] = useState('defaut');
    const [correspondanceFr, setCorrespondanceFr] = useState({});
    const [correspondanceEn, setCorrespondanceEn] = useState({});
    const [leftOptionsFr, setLeftOptionsFr] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);
    const [rightOptionsFr, setRightOptionsFr] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);
    const [leftOptionsEn, setLeftOptionsEn] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);
    const [rightOptionsEn, setRightOptionsEn] = useState([{ id: 1, value: '' }, { id: 2, value: '' }]);

    const user_id = localStorage.getItem('user_id');

    const [tag, setTag] = useState('');
    const [restriction, setRestriction] = useState('');
    const [statut, setStatut] = useState('');

    // États pour la mise en situation
    const [situations, setSituations] = useState([]);
    const [hasSituationFr, setHasSituationFr] = useState('non');
    const [situationFr, setSituationFr] = useState('');
    const [hasSituationEn, setHasSituationEn] = useState('non');
    const [situationEn, setSituationEn] = useState('');

    // Gestion des champs du formulaire avec useState
    const [questionFr, setQuestionFr] = useState('');
    const [ref, setRef] = useState('');
    const [approcheFr, setApprocheFr] = useState('');
    const [optionAFr, setOptionAFr] = useState('');
    const [optionBFr, setOptionBFr] = useState('');
    const [optionCFr, setOptionCFr] = useState('');
    const [optionDFr, setOptionDFr] = useState('');
    const [optionEFr, setOptionEFr] = useState('');
    const [optionFFr, setOptionFFr] = useState('');
    const [reponseFr, setReponseFr] = useState('');
    const [explicationFr, setExplicationFr] = useState('');
    const [niveauFr, setNiveauFr] = useState('');
    const [agileFr, setAgileFr] = useState(false);
    const [domaineFr, setDomaineFr] = useState('');
    const [groupeFr, setGroupeFr] = useState('');
    const [sourceFr, setSourceFr] = useState('');
    const [rattacheFr, setRattacheFr] = useState(false);
    const [ecoFr, setEcoFr] = useState('');

    const [questionEn, setQuestionEn] = useState('');
    const [approcheEn, setApprocheEn] = useState('');
    const [optionAEn, setOptionAEn] = useState('');
    const [optionBEn, setOptionBEn] = useState('');
    const [optionCEn, setOptionCEn] = useState('');
    const [optionDEn, setOptionDEn] = useState('');
    const [optionEEn, setOptionEEn] = useState('');
    const [optionFEn, setOptionFEn] = useState('');
    const [reponseEn, setReponseEn] = useState('');
    const [explicationEn, setExplicationEn] = useState('');
    const [niveauEn, setNiveauEn] = useState('');
    const [agileEn, setAgileEn] = useState(false);
    const [domaineEn, setDomaineEn] = useState('');
    const [groupeEn, setGroupeEn] = useState('');
    const [refEn, setRefEn] = useState('');
    const [sourceEn, setSourceEn] = useState('');
    const [rattacheEn, setRattacheEn] = useState(false);
    const [ecoEn, setEcoEn] = useState('');

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter QCM";
        }
    }, [user_id]);

    const options = [
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "D", label: "D" },
        { value: "E", label: "E" },
        { value: "F", label: "F" },
    ];

    const fetchDomaines = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/Liste-domaine/');
            if (response.ok) {
                const data = await response.json();
                setDomainesFr(data);
            }
        } catch (error) {
        }
    };

    // Récupération des situations
    const fetchSituations = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-situation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (response.ok) {
                const data = await response.json();
                setSituations(data);
            } else {
                console.error('Erreur lors de la récupération des situations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const [ecos, setEcos] = useState([]);
    const fetchEcos = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-eco/');
            if (response.ok) {
                const data = await response.json();
                setEcos(data);
            } else {
                console.error('Erreur lors de la récupération des ecos');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    const fetchGroupeProcessus = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
            if (response.ok) {
                const data = await response.json();
                setGroupeProcessusFr(data);
            } else {
                console.error('Erreur lors de la récupération des groupes processus');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchDomaines();
        fetchGroupeProcessus();
        fetchEcos();
        fetchSituations();
    }, []);

    const handleChangeReponseEn = (selectedOptions) => {
        setReponseEn(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleChangeReponseFr = (selectedOptions) => {
        setReponseFr(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const restrictions = [
        { value: "Simulateur", label: "Simulateur" },
        { value: "Examen_blanc", label: "Examen blanc" },
        { value: "Evaluation", label: "Evaluation" },
        { value: "Etude_de_cas", label: "Etude de cas" },
    ];

    const handleChangeRestriction = (selectedOptions) => {
        setRestriction(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const navigate = useNavigate();

    const uploadImages = async (htmlContent) => {
        const imgTags = htmlContent.match(/<img[^>]+src="([^">]+)"/g) || [];
        let updatedContent = htmlContent;

        for (let imgTag of imgTags) {
            const srcMatch = imgTag.match(/src="([^"]+)"/);
            if (srcMatch && srcMatch[1]) {
                const localUrl = srcMatch[1];

                if (!localUrl.startsWith('http')) {
                    const response = await fetch(localUrl);
                    const blob = await response.blob();
                    const formData = new FormData();
                    formData.append('image', blob, 'image.jpg');

                    const uploadResponse = await fetch(`${process.env.REACT_APP_HOTE}/upload-image/`, {
                        method: 'POST',
                        body: formData,
                    });

                    if (uploadResponse.ok) {
                        const data = await uploadResponse.json();
                        updatedContent = updatedContent.replace(localUrl, data.image_url);
                    }
                }
            }
        }

        return updatedContent;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const updatedQuestionFr = await uploadImages(questionFr);
        const updatedQuestionEn = await uploadImages(questionEn);

        const formDataFr = {
            question: updatedQuestionFr,
            tag: tag,
            ref: ref,
            approche: approcheFr,
            optionAFr: optionAFr,
            optionBFr: optionBFr,
            optionCFr: optionCFr,
            optionDFr: optionDFr,
            optionEFr: optionEFr,
            optionFFr: optionFFr,
            reponse: reponseFr,
            explication: explicationFr,
            niveau: niveauFr,
            agile: agileFr,
            domaine: domaineFr,
            groupeFr: groupeFr,
            source: sourceFr,
            rattache: rattacheFr,
            eco: ecoFr,
            statut: statut,
            restriction: restriction,
            type_question: typeQuestionFr,
            correspondance: typeQuestionFr === 'correspondance' ? JSON.stringify({
                leftOptions: leftOptionsFr,
                rightOptions: rightOptionsFr,
                pairs: correspondanceFr
            }) : null,
            has_situation: hasSituationFr,
            situation_id: hasSituationFr === 'oui' ? situationFr : null,
        };

        const formDataEn = {
            question: updatedQuestionEn,
            tag: tag,
            ref: refEn,
            approche: approcheEn,
            optionAEn: optionAEn,
            optionBEn: optionBEn,
            optionCEn: optionCEn,
            optionDEn: optionDEn,
            optionEEn: optionEEn,
            optionFEn: optionFEn,
            reponse: reponseEn,
            explication: explicationEn,
            niveau: niveauEn,
            agile: agileEn,
            domaine: domaineEn,
            groupeEn: groupeEn,
            source: sourceEn,
            rattache: rattacheEn,
            eco: ecoEn,
            statut: statut,
            restriction: restriction,
            type_question: typeQuestionEn,
            correspondance: typeQuestionEn === 'correspondance' ? JSON.stringify({
                leftOptions: leftOptionsEn,
                rightOptions: rightOptionsEn,
                pairs: correspondanceEn
            }) : null,
            has_situation: hasSituationEn,
            situation_id: hasSituationEn === 'oui' ? situationEn : null,
        };

        if (!ref) {
            showAlert('Champs Référence obligatoire', 'danger')
            return;
        }

        if (!questionFr) {
            showAlert('Champs question obligatoire', 'danger')
            return;
        }

        if (typeQuestionFr === 'defaut') {
            if (!optionAFr || !optionBFr) {
                showAlert('Veuillez renseigner au moins deux options', 'danger')
                return;
            }
            if (!reponseFr) {
                showAlert('Champs réponse obligatoire', 'danger')
                return;
            }
        } else if (typeQuestionFr === 'correspondance') {
            const hasEmptyLeft = leftOptionsFr.some(opt => !opt.value.trim());
            const hasEmptyRight = rightOptionsFr.some(opt => !opt.value.trim());
            if (hasEmptyLeft || hasEmptyRight) {
                showAlert('Veuillez remplir tous les items et correspondances', 'danger');
                return;
            }
            const leftIds = leftOptionsFr.map(opt => opt.id);
            const allPaired = leftIds.every(id => correspondanceFr[id] !== undefined);
            if (!allPaired) {
                showAlert('Veuillez établir toutes les correspondances', 'danger');
                return;
            }
        }

        if (!tag) {
            showAlert('Tag obligatoire', 'danger')
            return;
        }

        // Validation de la mise en situation
        if (hasSituationFr === 'oui' && !situationFr) {
            showAlert('Veuillez sélectionner une mise en situation', 'danger');
            return;
        }

        try {
            const responseFr = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-qcm-fr/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formDataFr),
            });

            if (questionEn) {
                const responseEn = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-qcm-en/${user_id}/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formDataEn),
                });

                if (responseEn.ok) {
                    const dataEn = await responseEn.json();
                    navigate(`/Liste-qcm`);
                } else {
                    const errorDataEn = await responseEn.json();
                    showAlert(errorDataEn, 'danger')
                }
            }

            if (responseFr.ok) {
                const dataFr = await responseFr.json();
                navigate(`/Liste-qcm`);
            } else {
                const errorDataFr = await responseFr.json();
                showAlert(errorDataFr, 'danger')
            }
        } catch (error) {
            console.error('Erreur lors de la soumission:', error);
            showAlert('Une erreur est survenue lors de la soumission', 'danger');
        }
    };

    const [alert, setAlert] = useState({ message: '', type: '' });
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    }

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
                if (response.ok) {
                    const data = await response.json();
                    setTags(data);
                }
            } catch (error) {
            }
        };

        fetchTags();
    }, []);

    const handleSelectChange = (e) => {
        const options = e.target.options;
        const selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selected.push(options[i].value);
            }
        }
        setSelectedTags(selected);
    };

    const removeTag = (tagToRemove) => {
        setSelectedTags(selectedTags.filter(tag => tag !== tagToRemove));
    };

    const handleCancel = () => {
        window.location.reload();
    };
    const [value, setValue] = useState('');

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
            [{ 'align': [] }],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ],
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaRegQuestionCircle size={25} className='mr-2' /> Nouveau QCM</h2>
                            <small>Administration des QCMs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-qcm`}>QCM</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Ajouter-qcm`}>Nouveau QCM</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                            <div
                                dangerouslySetInnerHTML={{ __html: alert.message }}
                            />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <div className="col-lg-12 mt-5 wrapper wrapper-content animated fadeInRight">
                        <div className="ibox ">
                            <div className="ibox-title">
                                <h5>Ajouter QCM</h5>
                                <div className="ibox-tools">
                                    <a className="collapse-link">
                                        <i className="fa fa-chevron-up"></i>
                                    </a>
                                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                                        <i className="fa fa-wrench"></i>
                                    </a>
                                    <ul className="dropdown-menu dropdown-user">
                                        <li><a href="#" className="dropdown-item">Config option 1</a>
                                        </li>
                                        <li><a href="#" className="dropdown-item">Config option 2</a>
                                        </li>
                                    </ul>
                                    <a className="close-link">
                                        <i className="fa fa-times"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-sm-6 b-r">
                                        <form onSubmit={handleSubmit} id="qcmForm1" method="post">
                                            <div className="panel-body">
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="ref"><b>référence</b></label>
                                                    <input
                                                        type="text"
                                                        name="ref"
                                                        id="ref"
                                                        placeholder="Entrez la référence"
                                                        required
                                                        className="form-control"
                                                        value={ref}
                                                        onChange={(e) => setRef(e.target.value)}
                                                    />
                                                </div>

                                                <div className="form-group type-selector">
                                                    <label className="control-label"><b>Type de question</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="typeQuestionFr"
                                                        id="typeQuestionFr"
                                                        value={typeQuestionFr}
                                                        onChange={(e) => setTypeQuestionFr(e.target.value)}
                                                    >
                                                        <option value="defaut">Par défaut</option>
                                                        <option value="correspondance">Par correspondance</option>
                                                    </select>
                                                </div>

                                                {/* Nouveau champ Mise en situation */}
                                                <div className="form-group">
                                                    <label className="control-label"><b>Mise en situation</b></label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-4">
                                                            <label className="mr-2">
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationFr"
                                                                    value="non"
                                                                    checked={hasSituationFr === 'non'}
                                                                    onChange={(e) => {
                                                                        setHasSituationFr(e.target.value);
                                                                        if (e.target.value === 'non') {
                                                                            setSituationFr('');
                                                                        }
                                                                    }}
                                                                />
                                                                {' '}Non
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationFr"
                                                                    value="oui"
                                                                    checked={hasSituationFr === 'oui'}
                                                                    onChange={(e) => {
                                                                        setHasSituationFr(e.target.value);
                                                                    }}
                                                                />
                                                                {' '}Oui
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Select conditionnel pour les situations */}
                                                {hasSituationFr === 'oui' && (
                                                    <div className="form-group">
                                                        <label className="control-label"><b>Sélectionner une mise en situation</b></label>
                                                        <select
                                                            className="form-control"
                                                            value={situationFr}
                                                            onChange={(e) => setSituationFr(e.target.value)}
                                                        >
                                                            <option value="">Choisissez une mise en situation</option>
                                                            {situations.map((situation) => (
                                                                <option key={situation.id} value={situation.id}>
                                                                    {situation.titre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="form-group">
                                                    <input type="hidden" name="qcm_idFr" id="qcm_idFr" className="form-control" />
                                                    <label className="control-label" htmlFor="summernote_question"><b>Question</b></label>
                                                    <SummernoteEditor value={questionFr} onChange={setQuestionFr} />
                                                </div>

                                                {typeQuestionFr === 'defaut' ? (
                                                    <>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option1"><b>Option A</b></label>
                                                            <input
                                                                type="text"
                                                                name="option1Fr"
                                                                id="option1"
                                                                placeholder="Entrez Option A"
                                                                required
                                                                className="form-control"
                                                                value={optionAFr}
                                                                onChange={(e) => setOptionAFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option2"><b>Option B</b></label>
                                                            <input
                                                                type="text"
                                                                name="option2Fr"
                                                                id="option2"
                                                                placeholder="Entrez Option B"
                                                                required
                                                                className="form-control"
                                                                value={optionBFr}
                                                                onChange={(e) => setOptionBFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option3"><b>Option C</b></label>
                                                            <input
                                                                type="text"
                                                                name="option3Fr"
                                                                id="option3"
                                                                placeholder="Entrez Option C"
                                                                required
                                                                className="form-control"
                                                                value={optionCFr}
                                                                onChange={(e) => setOptionCFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option D</b></label>
                                                            <input
                                                                type="text"
                                                                name="option4Fr"
                                                                id="option4"
                                                                placeholder="Entrez Option D"
                                                                required
                                                                className="form-control"
                                                                value={optionDFr}
                                                                onChange={(e) => setOptionDFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option E</b></label>
                                                            <input
                                                                type="text"
                                                                name="option5Fr"
                                                                id="option5"
                                                                placeholder="Entrez Option E"
                                                                className="form-control"
                                                                value={optionEFr}
                                                                onChange={(e) => setOptionEFr(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option F</b></label>
                                                            <input
                                                                type="text"
                                                                name="option6Fr"
                                                                id="option6"
                                                                placeholder="Entrez Option F"
                                                                className="form-control"
                                                                value={optionFFr}
                                                                onChange={(e) => setOptionFFr(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="control-label"><b>Reponse</b></label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                value={options.filter(option => reponseFr.includes(option.value))}
                                                                onChange={handleChangeReponseFr}
                                                                placeholder="Selectionnez une ou plusieurs réponses"
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <QuestionCorrespondance
                                                        onChange={(left, right, pairs) => {
                                                            setLeftOptionsFr(left);
                                                            setRightOptionsFr(right);
                                                            setCorrespondanceFr(pairs);
                                                        }}
                                                    />
                                                )}

                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="Explication"><b>Explication</b></label>
                                                    <SummernoteEditor value={explicationFr} onChange={setExplicationFr} />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="niveau"><b>Niveau de difficulté</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="niveauFr"
                                                        id="niveau"
                                                        value={niveauFr}
                                                        onChange={(e) => setNiveauFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le niveau</option>
                                                        <option value="1">Niveau 1</option>
                                                        <option value="2">Niveau 2</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Aproche</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="approcheFr"
                                                        id="approche"
                                                        value={approcheFr}
                                                        onChange={(e) => setApprocheFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez l'approche</option>
                                                        <option value="Agile">Agile</option>
                                                        <option value="Agnostique">Agnostique</option>
                                                        <option value="Hybride">Hybride</option>
                                                        <option value="Prédictif">Prédictif</option>
                                                        <option value="Tout">Tout</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Domaine de connaissance</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="domaineFr"
                                                        id="domaine"
                                                        value={domaineFr}
                                                        onChange={(e) => setDomaineFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le domaine</option>
                                                        {domainesFr.map((domaine) => (
                                                            <option key={domaine.id} value={domaine.ordre}>
                                                                {domaine.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Tags</b></label>
                                                    <Select
                                                        isMulti
                                                        options={tags.map((tag) => ({
                                                            value: tag.titre,
                                                            label: tag.titre,
                                                        }))}
                                                        value={Array.isArray(tag) ? tag.map((tag) => ({
                                                            value: tag,
                                                            label: tag,
                                                        })) : []}
                                                        onChange={(selectedOptions) => {
                                                            const selectedTags = selectedOptions.map((option) => option.value);
                                                            setTag(selectedTags);
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Sélectionnez un ou plusieurs tags..."
                                                        styles={{
                                                            multiValue: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#0b5ed7",
                                                                color: "white",
                                                                borderRadius: "5px",
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                            }),
                                                            multiValueRemove: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                                ':hover': {
                                                                    backgroundColor: "#0b5ed7",
                                                                    color: "white",
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Groupe de processus</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="groupeFr"
                                                        id="groupe"
                                                        value={groupeFr}
                                                        onChange={(e) => setGroupeFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionnez le groupe</option>
                                                        {groupeProcessusFr.map((groupe_processus) => (
                                                            <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                                {groupe_processus.titre_fr}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Eco</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="ecoFr"
                                                        id="eco"
                                                        value={ecoFr}
                                                        onChange={(e) => setEcoFr(e.target.value)}
                                                    >
                                                        <option value="">Sélectionner un éco</option>
                                                        {ecos.map((eco) => (
                                                            <option key={eco.id} value={eco.ordre}>
                                                                {eco.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label className="control-label"><b>Restriction</b></label>
                                                    <Select
                                                        options={restrictions}
                                                        isMulti
                                                        value={restrictions.filter(option => restriction.includes(option.value))}
                                                        onChange={handleChangeRestriction}
                                                        placeholder="Selectionnez une ou plusieurs restrictions"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="source"><b>Source</b></label>
                                                    <input
                                                        type="text"
                                                        name="sourceFr"
                                                        id="source"
                                                        placeholder="Entrez Source"
                                                        required
                                                        className="form-control"
                                                        value={sourceFr}
                                                        onChange={(e) => setSourceFr(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="rattacheFr"
                                                            id="rattache"
                                                            className="i-checks mr-2"
                                                            checked={rattacheFr}
                                                            onChange={(e) => setRattacheFr(e.target.checked)}
                                                        />
                                                        Rattacher aux supports de cours du domaine
                                                    </label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="col-sm-6">
                                        <form onSubmit={handleSubmit} id="qcmForm2" method="post">
                                            <div className="panel-body">
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="refEn"><b>reference</b></label>
                                                    <input
                                                        type="text"
                                                        name="refEn"
                                                        id="refEn"
                                                        placeholder="Entrer reference"
                                                        required
                                                        className="form-control"
                                                        value={refEn}
                                                        onChange={(e) => setRefEn(e.target.value)}
                                                    />
                                                </div>

                                                <div className="form-group type-selector">
                                                    <label className="control-label"><b>Question Type</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="typeQuestionEn"
                                                        id="typeQuestionEn"
                                                        value={typeQuestionEn}
                                                        onChange={(e) => setTypeQuestionEn(e.target.value)}
                                                    >
                                                        <option value="defaut">Default</option>
                                                        <option value="correspondance">Correspondence</option>
                                                    </select>
                                                </div>

                                                {/* Nouveau champ Mise en situation EN */}
                                                <div className="form-group">
                                                    <label className="control-label"><b>Situation</b></label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-4">
                                                            <label className="mr-2">
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationEn"
                                                                    value="non"
                                                                    checked={hasSituationEn === 'non'}
                                                                    onChange={(e) => {
                                                                        setHasSituationEn(e.target.value);
                                                                        if (e.target.value === 'non') {
                                                                            setSituationEn('');
                                                                        }
                                                                    }}
                                                                />
                                                                {' '}No
                                                            </label>
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="hasSituationEn"
                                                                    value="oui"
                                                                    checked={hasSituationEn === 'oui'}
                                                                    onChange={(e) => {
                                                                        setHasSituationEn(e.target.value);
                                                                    }}
                                                                />
                                                                {' '}Yes
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Select conditionnel pour les situations EN */}
                                                {hasSituationEn === 'oui' && (
                                                    <div className="form-group">
                                                        <label className="control-label"><b>Select a situation</b></label>
                                                        <select
                                                            className="form-control"
                                                            value={situationEn}
                                                            onChange={(e) => setSituationEn(e.target.value)}
                                                        >
                                                            <option value="">Choose a situation</option>
                                                            {situations.map((situation) => (
                                                                <option key={situation.id} value={situation.id}>
                                                                    {situation.titre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                <div className="form-group">
                                                    <input type="hidden" name="qcm_idEn" id="qcm_id" className="form-control" />
                                                    <label className="control-label" htmlFor="summernote_question"><b>Question</b></label>
                                                    <SummernoteEditor value={questionEn} onChange={setQuestionEn} />
                                                </div>

                                                {typeQuestionEn === 'defaut' ? (
                                                    <>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option1"><b>Option A</b></label>
                                                            <input
                                                                type="text"
                                                                name="option1En"
                                                                id="option1"
                                                                placeholder="Enter Option A"
                                                                required
                                                                className="form-control"
                                                                value={optionAEn}
                                                                onChange={(e) => setOptionAEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option2"><b>Option B</b></label>
                                                            <input
                                                                type="text"
                                                                name="option2En"
                                                                id="option2"
                                                                placeholder="Enter Option B"
                                                                required
                                                                className="form-control"
                                                                value={optionBEn}
                                                                onChange={(e) => setOptionBEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option3"><b>Option C</b></label>
                                                            <input
                                                                type="text"
                                                                name="option3En"
                                                                id="option3"
                                                                placeholder="Enter Option C"
                                                                required
                                                                className="form-control"
                                                                value={optionCEn}
                                                                onChange={(e) => setOptionCEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option D</b></label>
                                                            <input
                                                                type="text"
                                                                name="option4En"
                                                                id="option4"
                                                                placeholder="Enter Option D"
                                                                required
                                                                className="form-control"
                                                                value={optionDEn}
                                                                onChange={(e) => setOptionDEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option E</b></label>
                                                            <input
                                                                type="text"
                                                                name="option5En"
                                                                id="option5"
                                                                placeholder="Enter Option E"
                                                                className="form-control"
                                                                value={optionEEn}
                                                                onChange={(e) => setOptionEEn(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="option4"><b>Option F</b></label>
                                                            <input
                                                                type="text"
                                                                name="option6En"
                                                                id="option6"
                                                                placeholder="Enter Option F"
                                                                className="form-control"
                                                                value={optionFEn}
                                                                onChange={(e) => setOptionFEn(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="control-label"><b>Answer</b></label>
                                                            <Select
                                                                options={options}
                                                                isMulti
                                                                value={options.filter(option => reponseEn.includes(option.value))}
                                                                onChange={handleChangeReponseEn}
                                                                placeholder="Select one or more answers"
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <QuestionCorrespondance
                                                        onChange={(left, right, pairs) => {
                                                            setLeftOptionsEn(left);
                                                            setRightOptionsEn(right);
                                                            setCorrespondanceEn(pairs);
                                                        }}
                                                    />
                                                )}

                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="Explication"><b>Explanation</b></label>
                                                    <SummernoteEditor value={explicationEn} onChange={setExplicationEn} />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="niveau"><b>Difficulty Level</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="niveauEn"
                                                        id="niveau"
                                                        value={niveauEn}
                                                        onChange={(e) => setNiveauEn(e.target.value)}
                                                    >
                                                        <option value="">Select level</option>
                                                        <option value="1">Level 1</option>
                                                        <option value="2">Level 2</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Approach</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="approcheEn"
                                                        id="approche"
                                                        value={approcheEn}
                                                        onChange={(e) => setApprocheEn(e.target.value)}
                                                    >
                                                        <option value="">Select an approach</option>
                                                        <option value="Agile">Agile</option>
                                                        <option value="Agnostique">Agnostique</option>
                                                        <option value="Hybride">Hybride</option>
                                                        <option value="Prédictif">Prédictif</option>
                                                        <option value="Tout">Tout</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Knowledge Domain</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="domaineEn"
                                                        id="domaine"
                                                        value={domaineEn}
                                                        onChange={(e) => setDomaineEn(e.target.value)}
                                                    >
                                                        <option value="">Select domain</option>
                                                        {domainesFr.map((domaine) => (
                                                            <option key={domaine.id} value={domaine.ordre}>
                                                                {domaine.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Tags</b></label>
                                                    <Select
                                                        isMulti
                                                        options={tags.map((tag) => ({
                                                            value: tag.titre,
                                                            label: tag.titre,
                                                        }))}
                                                        value={Array.isArray(tag) ? tag.map((tag) => ({
                                                            value: tag,
                                                            label: tag,
                                                        })) : []}
                                                        onChange={(selectedOptions) => {
                                                            const selectedTags = selectedOptions.map((option) => option.value);
                                                            setTag(selectedTags);
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Sélectionnez un ou plusieurs tags..."
                                                        styles={{
                                                            multiValue: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#0b5ed7",
                                                                color: "white",
                                                                borderRadius: "5px",
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                            }),
                                                            multiValueRemove: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                                ':hover': {
                                                                    backgroundColor: "#0b5ed7",
                                                                    color: "white",
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label><b>Process Group</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="groupeEn"
                                                        id="groupe"
                                                        value={groupeEn}
                                                        onChange={(e) => setGroupeEn(e.target.value)}
                                                    >
                                                        <option value="">Select group</option>
                                                        {groupeProcessusFr.map((groupe_processus) => (
                                                            <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                                {groupe_processus.titre_fr}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Eco</b></label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="ecoEn"
                                                        id="eco"
                                                        value={ecoEn}
                                                        onChange={(e) => setEcoEn(e.target.value)}
                                                    >
                                                        <option value="">Select eco</option>
                                                        {ecos.map((eco) => (
                                                            <option key={eco.id} value={eco.ordre}>
                                                                {eco.titre}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label className="control-label"><b>Restriction</b></label>
                                                    <Select
                                                        options={restrictions}
                                                        isMulti
                                                        value={restrictions.filter(option => restriction.includes(option.value))}
                                                        onChange={handleChangeRestriction}
                                                        placeholder="Selectionnez une ou plusieurs restrictions"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="source"><b>Source</b></label>
                                                    <input
                                                        type="text"
                                                        name="sourceEn"
                                                        id="source"
                                                        placeholder="Enter Source"
                                                        required
                                                        className="form-control"
                                                        value={sourceEn}
                                                        onChange={(e) => setSourceEn(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            name="rattacheEn"
                                                            id="rattache"
                                                            className="i-checks mr-2"
                                                            checked={rattacheEn}
                                                            onChange={(e) => setRattacheEn(e.target.checked)}
                                                        />
                                                        Attach to course materials of the domain
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label><b>Statut</b></label>
                                                    <select
                                                        className="form-control m-b w-50"
                                                        name="statut"
                                                        id="statut"
                                                        value={statut}
                                                        onChange={(e) => setStatut(e.target.value)}
                                                    >
                                                        <option value=""></option>
                                                        <option value="En Attente">En Attente</option>
                                                        <option value="Corriger">Corriger</option>
                                                        <option value="Approuvé">Approuvé</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="ibox-footer text-right m-3">
                                    <Link to="/Liste-qcm" className="btn btn-secondary mr-2">Retour</Link>
                                    <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel}>Annuler</button>
                                    <button type="submit" form="qcmForm1" className="btn btn-success">Enregistrer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ajouter_qcm;